// Cover Full (Homepage)
const coverFull = () => {
	if ($('.cover-full')[0]) {
		var vid = document.getElementById('coverFullVideo')
		vid.playbackRate = 0.85
		// Particle JS
		$('#particles-js').css({
			position: 'absolute',
			'z-index': '1',
			width: '100%',
		})
		particlesJS('particles-js', {
			particles: {
				number: { value: 33, density: { enable: true, value_area: 800 } },
				color: { value: '#ffffff' },
				shape: {
					type: 'circle',
					stroke: { width: 1, color: '#26242a' },
					polygon: { nb_sides: 3 },
					image: { src: '../img/customers.svg', width: 100, height: 100 },
				},
				opacity: {
					value: 0.5,
					random: false,
					anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
				},
				size: {
					value: 5,
					random: true,
					anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
				},
				line_linked: {
					enable: true,
					distance: 250,
					color: '#ffffff',
					opacity: 0.4,
					width: 1,
				},
				move: {
					enable: true,
					speed: 3,
					direction: 'bottom',
					random: false,
					straight: false,
					out_mode: 'bounce',
					bounce: false,
					attract: { enable: false, rotateX: 600, rotateY: 1200 },
				},
			},
			interactivity: {
				detect_on: 'canvas',
				events: {
					onhover: { enable: true, mode: 'grab' },
					onclick: { enable: false, mode: 'repulse' },
					resize: true,
				},
				modes: {
					grab: { distance: 300, line_linked: { opacity: 0.8 } },
					bubble: {
						distance: 400,
						size: 40,
						duration: 2,
						opacity: 8,
						speed: 3,
					},
					repulse: { distance: 392, duration: 0.4 },
					push: { particles_nb: 4 },
					remove: { particles_nb: 2 },
				},
			},
			retina_detect: true,
		})
	}
}
export { coverFull }
